import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="einkunftsart"
export default class extends Controller {
	static targets = ["select", "drv", "bvw", "ksk", "alo"]

	connect() {}

	updateSvangaben() {
		this.uncheckAll(["drv", "bvw", "ksk", "alo"])

		const drvAloEinkunftsarten = ["2", "4", "5", "300"]
		if (drvAloEinkunftsarten.includes(this.selectTarget.value)) {
			this.aktivieren(["drv", "alo"])
		}
	}

	uncheckAll(keys) {
		keys.forEach((key) => {
			const checkbox = this.getCheckbox(key)
			if (checkbox.checked) this.getButton(key).dispatchEvent(new Event("click"))
		})
	}

	aktivieren(keys) {
		keys.forEach((key) => {
			const checkbox = this.getCheckbox(key)
			if (!checkbox.checked) this.getButton(key).dispatchEvent(new Event("click"))
		})
	}

	getCheckbox(key) {
		return this[`${key}Target`].querySelector("input[type='checkbox'].sr-only")
	}

	getButton(key) {
		return this[`${key}Target`].querySelector("button[role='switch']")
	}
}
